<template>
  <div id="cliente-dados-gerais">
    <v-row>
        <v-col cols="12" lg="9" md="9" class="pb-0">
          <span class="text-h5">Dados Gerais</span>
        </v-col>
        <v-col cols="12" lg="3" md="3" class="pb-0 text-center">
          <v-chip outlined small>Situação: {{value.SituacaoDescricao}}</v-chip>
        </v-col>
        <v-col cols="12" lg="6" md="6">
          <span class="text-label">Documento Federal</span>
            <div v-if="value.Cliente">{{value.Cliente.DocumentoFederal}}</div>
        </v-col>
        <v-col cols="12" lg="6" md="6">
          <div v-if="value.Pessoa && value.Cliente.TipoPessoa === $aux.TipoPessoaEnum.PF">
            <span class="text-label">Data de Nascimento</span>
            {{$api.UI.Format.Date(value.Pessoa.PF.DtNasc)}}
          </div>
        </v-col>
        <v-col cols="6">
          <span class="text-label">Telefone (Celular)</span>
          <div v-if="value.Pessoa">{{value.Pessoa.PessoaDadosContato.TelefoneCelular1}}</div>
        </v-col>
        <v-col cols="6">
          <span class="text-label">E-mail</span>
          <div v-if="value.Pessoa">{{value.Pessoa.PessoaDadosContato.Email}}</div>
        </v-col>
        <v-col cols="12" >
          <span class="text-label">Nome / Razão Social</span>
          <div v-if="value.Pessoa">{{value.Pessoa.Nome}}</div>
        </v-col>
        <v-col cols="12" v-if="value.Pessoa && value.Cliente.TipoPessoa === $aux.TipoPessoaEnum.PF">
          <div >
            <span class="text-label">Nome da Mãe</span>
            {{value.Pessoa.PF.NomeMae}}
          </div>
        </v-col>
        <v-col cols="12">
          <span class="text-label">Endereço de Residência</span>
            <p v-if="value.Cliente.EnderecoResidencia">{{value.Cliente.EnderecoResidencia.Logradouro}}, {{value.Cliente.EnderecoResidencia.NroLogradouro}}, {{value.Cliente.EnderecoResidencia.Cidade}}, {{value.Cliente.EnderecoResidencia.UF}} - {{value.Cliente.EnderecoResidencia.CEP}}</p>
        </v-col>
        <v-col cols="6">
          <span class="text-label">Tipo de Operação</span>
          {{ value.TipoOperacaoDescricao }}
        </v-col>
        <v-col cols="6">
          <span class="text-label">Produto</span>
          {{ value.TipoContratoDescricao }}
        </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    model: { typeof: Object }
  },
  data () {
    return { }
  },
  computed: {
    value: {
      get () {
        return this.model
      },
      set (val) {
        this.$emit('input', val)
      }
    },
  },
  methods: {
    getDadosCliente () {
      const th = this;
      if (th.model.Cliente.DocumentoFederal) {
        th.$api.Multiplo.SelectPessoa({ filter: { tipoRegistro: 1, DocumentoCliente: th.model.Cliente.DocumentoFederal } }).then(pessoa => {
          if (th.$api.UI.PostLoadData(pessoa)) {
            const pessoaObject = JSON.parse(pessoa.JSON)
            th.$set(th.value, 'Pessoa', pessoaObject)
            const dtoPessoa = { parameters: [{ name: 'CodigoPessoa', value: (th.model.Cliente.Codigo || th.model.Pessoa.Codigo) }] }
            th.$api.Multiplo.ListPessoaEndereco(dtoPessoa).then(endereco => {
              if (th.$api.UI.PostLoadData(endereco) && endereco.Data.length > 0) {
                th.$set(th.value.Cliente, 'EnderecoResidencia', endereco.Data[endereco.Data.length - 1])
              }
            })
          }
        })
        th.$api.Multiplo.ListPessoaQualificacao({ parameters: [{ name: 'CodigoPessoa', value: th.model.Cliente.Codigo }] }).then(qualificacao => {
          if (th.$api.UI.PostLoadData(qualificacao) && qualificacao.Data.length > 0) {
            th.$set(th.value.Cliente, 'PessoaQualificacao', qualificacao.Data[qualificacao.Data.length - 1])
          }
        })
      }
    },
  },
  mounted () {
    this.$emit('mounted')
    if (this.model.Cliente.DocumentoFederal) {
      this.getDadosCliente()
    }
  }
}
</script>
